export default __webpack_public_path__ + "static/media/ing.4da8856b.jpg";